/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Pain_Add_FirstInputs */

const en_us2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log a pain or injury`)
};

const pt_br2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar uma dor ou lesão`)
};

const es_419_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar un dolor o lesión`)
};

const pt_pt2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar uma dor ou lesão`)
};

const fr_fr2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler une douleur ou une blessure`)
};

const de_de2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerz oder Verletzung eintragen`)
};

const it_it2_profile_pain_add_first = /** @type {(inputs: Profile_Pain_Add_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra un dolore o un infortunio`)
};

/**
* | output |
* | --- |
* | "Log a pain or injury" |
*
* @param {Profile_Pain_Add_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pain_add_first = /** @type {((inputs?: Profile_Pain_Add_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pain_Add_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pain_add_first(inputs)
	if (locale === "es-419") return es_419_profile_pain_add_first(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pain_add_first(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pain_add_first(inputs)
	if (locale === "de-DE") return de_de2_profile_pain_add_first(inputs)
	if (locale === "it-IT") return it_it2_profile_pain_add_first(inputs)
	return en_us2_profile_pain_add_first(inputs)
});
export { profile_pain_add_first as "profile.pain_add_first" }